import { createAction } from '@reduxjs/toolkit';
import { addNamespace } from '@Utils/actions';
import {
	EditIntegrationParams,
	CreateIntegrationParams,
	Integration,
	ListIntegrationsParams,
	ValidateITPipesApiKeyPayload,
} from '../../types/integration.types';
import { VAPARLoginParams } from 'features/IntegrationsTab/types/integration.types';

export const validateITPipesApiKey = createAction<ValidateITPipesApiKeyPayload>(
	addNamespace('integrations/validateITPipesApiKey'),
);
export const validateITPipesApiKeyResolved = createAction(
	addNamespace('integrations/validateITPipesApiKey/resolved'),
);
export const validateITPipesApiKeyRejected = createAction(
	addNamespace('integrations/validateITPipesApiKey/rejected'),
);

export const clearIntegrations = createAction(
	addNamespace('integrations/clear'),
);

export const getIntegrations = createAction<ListIntegrationsParams>(
	addNamespace('integrations/getIntegrations/all'),
);
export const getIntegrationsResolved = createAction<Integration[] | undefined>(
	addNamespace('integrations/getIntegrations/all/resolved'),
);
export const getIntegrationsRejected = createAction(
	addNamespace('integrations/getIntegrations/all/rejected'),
);

export const createIntegration = createAction<CreateIntegrationParams>(
	addNamespace('integrations/createIntegration'),
);
export const createIntegrationResolved = createAction<Integration>(
	addNamespace('integrations/createIntegration/resolved'),
);
export const createIntegrationRejected = createAction(
	addNamespace('integrations/createIntegration/rejected'),
);

export const getSingleIntegrationById = createAction<string>(
	addNamespace('integrations/getSingleIntegrationById'),
);
export const getSingleIntegrationByIdResolved =
	createAction<EditIntegrationParams>(
		addNamespace('integrations/getSingleIntegrationById/resolved'),
	);
export const getSingleIntegrationByIdRejected = createAction(
	addNamespace('integrations/getSingleIntegrationById/rejected'),
);
export const updateIntegration = createAction<EditIntegrationParams>(
	addNamespace('integrations/updateIntegration'),
);
export const updateIntegrationResolved = createAction(
	addNamespace('integrations/updateIntegration/resolved'),
);
export const updateIntegrationRejected = createAction(
	addNamespace('integrations/updateIntegration/rejected'),
);
export const deleteIntegration = createAction<string>(
	addNamespace('integrations/integrations/delete'),
);
export const deleteIntegrationResolved = createAction(
	addNamespace('integrations/integrations/delete/resolved'),
);
export const deleteIntegrationRejected = createAction(
	addNamespace('integrations/integrations/delete/rejected'),
);

export const vaparLogin = createAction<VAPARLoginParams>(
	addNamespace('vapar/login'),
);
